import React from 'react';
import EmptyQna from './EmptyQna';
import MyQnaRow from './MyQnaRow';
import { BaseButton } from '@repo/common';
import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-bottom.svg';
import { ReactComponent as ArrowTopIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-top.svg';

const MyQnaList = ({ qnaList = [], hasMore, onLoadMore, totalCount }) => {
  if (qnaList.length === 0) {
    return (
      <div className='w-full flex flex-col overflow-hidden'>
        <div className='tabletH:pb-10 flex flex-col gap-3 tabletH:min-h-[400px]'>
          <EmptyQna />
        </div>
      </div>
    );
  }

  return (
    <div className='w-full flex flex-col overflow-hidden'>
      <div className='tabletH:pb-10 flex flex-col gap-2'>
        {qnaList.map((item) => (
          <MyQnaRow key={item.qnaId} item={item} />
        ))}

        {totalCount > 2 && (
          <BaseButton
            type='text_basic'
            size='l'
            icon={hasMore ? <ArrowBottomIcon /> : <ArrowTopIcon />}
            onClick={onLoadMore}
          >
            {hasMore ? 'View more' : 'View less'}
          </BaseButton>
        )}
      </div>
    </div>
  );
};

export default MyQnaList;
